import styled from 'styled-components'

import { Flex } from 'Components/UI'

import { LANDING_INLINE_PADDINGS, PY_BLUEPRINT } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  my: PY_BLUEPRINT,
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;
`

export const Content = styled(Flex)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  z-index: 11;
`

export const StepsWrapper = styled(Flex).attrs({
  mt: ['27px', '27px', '50px'],
})`
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
`
